import { render, staticRenderFns } from "./LoadContent.vue?vue&type=template&id=d138293a&scoped=true&"
import script from "./LoadContent.vue?vue&type=script&lang=js&"
export * from "./LoadContent.vue?vue&type=script&lang=js&"
import style0 from "./LoadContent.vue?vue&type=style&index=0&id=d138293a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d138293a",
  null
  
)

export default component.exports